import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

// import "quill/dist/quill.core.css";
// import "quill/dist/quill.snow.css";
// import "quill/dist/quill.bubble.css";

// import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import "./../public/style.css";
// import '../static/css/theme-green/index.css';       // 浅绿色主题
import "babel-polyfill";
import api from "./assets/javascript/axios"; // 请求封装
import tools from "./assets/javascript/tools"; // 公共方法
import url from "./assets/javascript/url"; // 公共方法
import rules from "./assets/javascript/rules"; // 公共方法
import "./assets/css/style.less"; // 公共样式
import "./assets/javascript/module"; // 组件注册
import VueCookies from "vue-cookies";
import "./assets/css/index.less";
import store from "./store"; //引入store
//import NProgress from 'nprogress' // 进度条
//import 'nprogress/nprogress.css' //这个样式必须引入

// router.beforeEach((to, from, next) => {
//   if (to.path == '/collectMoney') {
//     console.log(store);
//     // next("/");
//   }
//   next()
// })

import Print from './assets/javascript/print'
Vue.use(Print);

// 简单配置
// NProgress.inc(0.2)
// NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false })
Vue.use(VueCookies); //cookie
import VueContextMenu from "vue-contextmenu";
Vue.use(VueContextMenu);
Vue.prototype.$api = api;
Vue.prototype.$rules = rules;
Vue.prototype.$url = url; // url地址全局挂载
Vue.prototype.$tools = tools;
Vue.prototype.$handleClose = (done) => {
    done(); // 全局弹窗关闭方法
};
Vue.config.productionTip = false;
Vue.use(ElementUI, {
    size: "small",
});

//创建自定义指令
import directive from "./directive";
Object.keys(directive).forEach((key) => {
    Vue.directive(key, directive[key]); //注册自定义指令
});
new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");